import script from "./Activity_MainvisualTest.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_MainvisualTest.vue?vue&type=script&setup=true&lang=js"

import "./Activity_MainvisualTest.vue?vue&type=style&index=0&id=fceeb93e&lang=less&scoped=true"
import "./Activity_MainvisualTest.vue?vue&type=style&index=1&id=fceeb93e&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fceeb93e"]])

export default __exports__